import * as types from './types'

export default {
  [types.MESSAGE]: state => {
    return state.message
  }
}
